import React, { useState } from 'react';
import {
  Form,
  Input,
  Label,
  Button,
  FormGroup,
  FormFeedback,
} from 'reactstrap';

import { InputValidation } from 'services';

import './login-box.scss';
import * as yup from 'yup';

export function LoginBox({ loginData }) {
  const populateObject = (invalid, message) => {
    return {
      invalid,
      message,
    };
  };

  const [email, setEmail] = useState(populateObject(false, ''));
  const [password, setPassword] = useState(populateObject(false, ''));

  const returnLoginData = () => {
    loginData({
      email,
      password,
    });
  };

  const addressSchema = yup.object().shape({
    password: yup.string().required(),
    email: yup.string().email().required(),
  });

  const loginFormData = {
    email: email.value,
    password: password.value,
  };

  const getPopulateObject = (input, value) => {
    const inputs = {
      password: () => {
        setPassword(populateObject(true, value));
      },
      email: () => {
        setEmail(populateObject(true, value));
      },
    };
    return inputs[input] ? inputs[input]() : returnLoginData();
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const feedback = await Promise.resolve(
      InputValidation({ schema: addressSchema, formdata: loginFormData })
    ).then((value) => value);

    if(feedback?.id) {
      return feedback.id.forEach((element, index) => {
        getPopulateObject(element, feedback.error[index] );
      });
    }

    return getPopulateObject(feedback?.id);
  };

  return (
    <Form className="login-box shadow-sm px-3 py-5" onSubmit={(event) => handleSubmit(event)}>
      <FormGroup sm={5}>
        <Label for="email" sm={5}>
          {' '}
          Usuário:{' '}
        </Label>
        <Input
          invalid={email.invalid}
          onChange={(e) => setEmail({ value: e.target.value })}
          type="email"
          name="email"
          placeholder="Ex: email@email.com.br"
        />
        <FormFeedback id="name"> {email.message} </FormFeedback>
      </FormGroup>
      <FormGroup>
        <Label for="email" sm={5}>
          {' '}
          Senha:{' '}
        </Label>
        <Input
          invalid={password.invalid}
          onChange={(e) => setPassword({ value: e.target.value })}
          type="password"
          name="password"
          placeholder="*******"
        />
        <FormFeedback id="name"> {password.message} </FormFeedback>
      </FormGroup>
      <FormGroup>
        <Button color="primary" className="px-4">
          Entrar
        </Button>
      </FormGroup>
    </Form>
  );
}
